import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/* ── SVG Icon helpers ── */
const icons = {
  crown: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 4l3 12h14l3-12-5 4-5-4-5 4-3-4z"/><path d="M3 20h18"/>
    </svg>
  ),
  package: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.5 9.4l-9-5.19"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  mail: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  printer: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
    </svg>
  ),
  stamp: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 21h14"/><path d="M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4"/><path d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>
    </svg>
  ),
  shield: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  shred: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="8" rx="1"/><path d="M17 14v7"/><path d="M7 14v7"/><path d="M12 14v7"/><path d="M4 6V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  check: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  mapPin: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  clock: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  users: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  globe: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  truck: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  ),
  phone: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  arrowRight: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
};

function Home() {
  useEffect(() => {
    document.title = 'Royal Parcel | Pack, Ship & Mail Services in North Hollywood, CA';
    document.querySelector('meta[name="description"]')?.setAttribute('content',
      'Royal Parcel in North Hollywood, CA — pack, ship, and receive mail & packages at one secure location. Private mailboxes with a real street address, notary public, printing, copying, scanning, fax, shredding, laminating, and international shipping on Magnolia Blvd.'
    );
  }, []);

  return (
    <>
      {/* ━━━ HERO ━━━ */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-pattern"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              {icons.crown}
              <span>North Hollywood's Premier Postal Center</span>
            </div>

            <h1 className="hero-title">
              The World Is Yours<br />
              To <span className="gold">Ship Around</span>
            </h1>

            <p className="hero-title-tagline">
              Your New Personal Royal Address
            </p>

            <p className="hero-description">
              Pack, ship, and receive all your mail & packages at one secure location.
              From private mailboxes with a real street address to notary services
              — experience premium postal care in the heart of NoHo.
            </p>

            <div className="hero-buttons">
              <Link to="/services" className="btn btn-primary">
                Our Services {icons.arrowRight}
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Get In Touch
              </Link>
            </div>

            <div className="hero-info-bar">
              <div className="hero-info-item">
                <div className="number">Major</div>
                <div className="label">Carriers</div>
              </div>
              <div className="hero-info-item">
                <div className="number">100%</div>
                <div className="label">Secure Mailboxes</div>
              </div>
              <div className="hero-info-item">
                <div className="number">NoHo</div>
                <div className="label">Local & Trusted</div>
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-logo-container">
              <div className="hero-logo-ring"></div>
              <div className="hero-logo-ring"></div>
              <div className="hero-logo-ring"></div>
              <div className="hero-logo-image">
                <img src="/images/logo.png" alt="Royal Parcel - Ship Like Royalty Today" />
              </div>
            </div>
          </div>
        </div>

        <div className="scroll-indicator" onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}>
          <span className="scroll-text">Scroll to explore</span>
          <div className="scroll-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>
        </div>
      </section>

      {/* ━━━ CARRIER LOGOS BAR ━━━ */}
      <section className="carriers-bar">
        <div className="container">
          <span className="carrier-label">Trusted Carrier Partners</span>
          <div className="carrier-logos">
            <span className="carrier-logo ups">UPS</span>
            <span className="carrier-logo usps">USPS</span>
          </div>
        </div>
      </section>

      {/* ━━━ SERVICES OVERVIEW ━━━ */}
      <section className="services-overview">
        <div className="container">
          <div className="section-header">
            <p className="section-overline">What We Offer</p>
            <h2 className="section-title">Premium Postal Services</h2>
            <p className="section-subtitle">
              Everything you need under one roof — from worldwide shipping to secure
              document services, all handled with royal care.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-card-icon">{icons.package}</div>
              <h3>Pack & Ship</h3>
              <p>
                Professional packing and worldwide shipping through major carriers.
                Your packages, handled with care.
              </p>
            </div>

            <div className="service-card">
              <div className="service-card-icon">{icons.mail}</div>
              <h3>Private Mailboxes</h3>
              <p>
                Get a real street address — not a P.O. Box. Receive mail and packages
                securely at your convenience with your personal royal mailbox.
              </p>
            </div>

            <div className="service-card">
              <div className="service-card-icon">{icons.stamp}</div>
              <h3>Notary Public</h3>
              <p>
                Professional notary services available during business hours. Get your
                important documents notarized quickly and conveniently.
              </p>
            </div>

            <div className="service-card">
              <div className="service-card-icon">{icons.printer}</div>
              <h3>Print & Copy</h3>
              <p>
                High-quality printing, copying, scanning, and fax services for all your
                personal and business document needs.
              </p>
            </div>

            <div className="service-card">
              <div className="service-card-icon">{icons.shred}</div>
              <h3>Secure Shredding</h3>
              <p>
                Protect your sensitive information with our secure document shredding 
                service. Laminating services also available.
              </p>
            </div>

            <div className="service-card">
              <div className="service-card-icon">{icons.globe}</div>
              <h3>International Shipping</h3>
              <p>
                Ship anywhere in the world with competitive rates and reliable tracking.
                The world truly is yours to ship around.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ MAILBOX APPLICATION FORMS ━━━ */}
      <section className="home-forms-banner">
        <div className="container">
          <div className="home-forms-card">
            <div className="home-forms-content">
              <div className="home-forms-badge">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
                <span>Private Mailbox Setup</span>
              </div>
              <h2>Get Your Royal Mailbox</h2>
              <p>
                Ready for a real street address? Download and complete the USPS Form 1583-1
                to get started with your private mailbox. Bring it in and we'll handle the rest.
              </p>
            </div>
            <div className="home-forms-downloads">
              <div className="home-form-item">
                <div className="home-form-item-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                </div>
                <div className="home-form-item-info">
                  <h4>USPS Form 1583-1</h4>
                  <span>Mail Delivery Authorization</span>
                </div>
                <div className="home-form-item-actions">
                  <a href="/forms/usps-form-1583-1.pdf" target="_blank" rel="noopener noreferrer" className="home-form-btn home-form-btn--preview" aria-label="Preview Form 1583-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    Preview
                  </a>
                  <a href="/forms/usps-form-1583-1.pdf" download className="home-form-btn home-form-btn--download" aria-label="Download Form 1583-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    Download
                  </a>
                </div>
              </div>
              <div className="home-form-item">
                <div className="home-form-item-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                </div>
                <div className="home-form-item-info">
                  <h4>USPS Form 1583-2</h4>
                  <span>Instructions &amp; Agreement</span>
                </div>
                <div className="home-form-item-actions">
                  <a href="/forms/usps-form-1583-2.pdf" target="_blank" rel="noopener noreferrer" className="home-form-btn home-form-btn--preview" aria-label="Preview Form 1583-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    Preview
                  </a>
                  <a href="/forms/usps-form-1583-2.pdf" download className="home-form-btn home-form-btn--download" aria-label="Download Form 1583-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    Download
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ WHY CHOOSE US ━━━ */}
      <section className="why-section">
        <div className="container">
          <div className="why-grid">
            <div className="why-content">
              <div className="section-header">
                <p className="section-overline section-overline--light">Why Royal Parcel</p>
                <h2 className="section-title section-title--light">
                  Ship Like Royalty Today
                </h2>
                <p className="section-subtitle section-subtitle--light">
                  We're not just another postal shop. We're your neighborhood shipping partner, 
                  dedicated to providing a premium experience every visit.
                </p>
              </div>

              <div className="why-features">
                <div className="why-feature">
                  <div className="why-feature-icon">{icons.mapPin}</div>
                  <div>
                    <h4>Real Street Address</h4>
                    <p>Get a prestigious Magnolia Blvd. address for your business or personal use — no P.O. Box numbers.</p>
                  </div>
                </div>
                <div className="why-feature">
                  <div className="why-feature-icon">{icons.shield}</div>
                  <div>
                    <h4>Secure & Reliable</h4>
                    <p>Your packages and mail are kept safe in our secure facility until you're ready to pick them up.</p>
                  </div>
                </div>
                <div className="why-feature">
                  <div className="why-feature-icon">{icons.users}</div>
                  <div>
                    <h4>Friendly Local Service</h4>
                    <p>Our experienced team provides personalized attention and care for every customer who walks through our door.</p>
                  </div>
                </div>
                <div className="why-feature">
                  <div className="why-feature-icon">{icons.truck}</div>
                  <div>
                    <h4>All Carriers, One Stop</h4>
                    <p>Compare rates across major carriers to find the best option for your shipment.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="why-image">
              <div className="why-image-card">
                <img src="/images/logo.png" alt="Royal Parcel Logo" />
                <div className="why-stats">
                  <div className="why-stat">
                    <div className="number">Major</div>
                    <div className="label">Carriers</div>
                  </div>
                  <div className="why-stat">
                    <div className="number">100%</div>
                    <div className="label">Secure Mailboxes</div>
                  </div>
                  <div className="why-stat">
                    <div className="number">6 Days</div>
                    <div className="label">Open/Week</div>
                  </div>
                  <div className="why-stat">
                    <div className="number">NoHo</div>
                    <div className="label">Locally Owned</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ CTA BANNER ━━━ */}
      <section className="cta-banner">
        <div className="container">
          <h2>Ready to Ship Like Royalty?</h2>
          <p>Visit us today or give us a call. We're here to handle all your shipping, mailing, and business service needs.</p>
          <Link to="/contact" className="btn">
            Contact Us Today {icons.arrowRight}
          </Link>
        </div>
      </section>

      {/* ━━━ HOURS & INFO ━━━ */}
      <section className="hours-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '0' }}>
            <p className="section-overline" style={{ justifyContent: 'center' }}>
              <span style={{ display: 'none' }}>—</span>Visit Us
            </p>
            <h2 className="section-title">Hours & Location</h2>
          </div>

          <div className="hours-grid">
            <div className="hours-card">
              <h3>
                {icons.clock}
                Business Hours
              </h3>
              <div className="hours-item">
                <span className="day">Monday – Friday</span>
                <span className="time">9:30 AM – 6:00 PM</span>
              </div>
              <div className="hours-item">
                <span className="day">Saturday</span>
                <span className="time">9:30 AM – 1:00 PM</span>
              </div>
              <div className="hours-item">
                <span className="day">Sunday</span>
                <span className="time closed">Closed</span>
              </div>
            </div>

            <div className="hours-card">
              <h3>
                {icons.mapPin}
                Our Address
              </h3>
              <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-muted)' }}>
                <strong style={{ color: 'var(--navy)' }}>Royal Parcel</strong><br />
                11104 Magnolia Blvd.<br />
                North Hollywood, CA 91601
              </p>
              <br />
              <a
                href="https://maps.google.com/?q=11104+Magnolia+Blvd+North+Hollywood+CA+91601"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline"
                style={{ padding: '12px 24px', fontSize: '0.85rem' }}
              >
                Get Directions {icons.arrowRight}
              </a>
            </div>

            <div className="hours-card">
              <h3>
                {icons.phone}
                Get In Touch
              </h3>
              <div className="hours-item">
                <span className="day">Phone</span>
                <span className="time"><a href="tel:+18182993899" style={{ color: 'var(--gold-dark)' }}>(818) 299-3899</a></span>
              </div>
              <div className="hours-item">
                <span className="day">Fax</span>
                <span className="time">(818) 505-3111</span>
              </div>
              <div className="hours-item">
                <span className="day">Email</span>
                <span className="time">
                  <a href="mailto:royalparcelnoho@gmail.com" style={{ color: 'var(--gold-dark)', fontSize: '0.85rem' }}>
                    royalparcelnoho@gmail.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
